module.exports = __webpack_public_path__ + "img/no-stCommonwealth.4bc48db1.svg";